module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Smile-378ed5e8b5878867371c7d611c5253fd.svg";